import React from 'react'

function ShareWithTeamIcon(props) {
    return (
        <svg width="36" height="33" viewBox="0 0 36 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M16.0495 22.0148L27.0131 11.0513L26.8946 17.8069L29.9126 17.7694L30.1216 5.85359L18.2056 6.06241L18.168 9.08027L24.9236 8.9618L13.9601 19.9253L16.0495 22.0148Z" fill="black" />
            <path d="M13.5747 7.38063H2V31.0324H28.4416V23.2672" stroke="black" strokeWidth="3" />
        </svg>
    )
}

export default ShareWithTeamIcon
